import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import { ButtonContainer } from '../styles';

// Components
import { MainButton } from '../../../inputs/buttons/MainButton';

// Types
import { OrderState } from '../../../../types/orders';
import { type ActionWizardFooterProps } from './types';

/**
 * Pie del PASO TERMINAL del asistente de actuación: Guardar / Validar /
 * Pendent de certificar.
 *
 * Vivía dentro de `AnimalsForm` porque Animals era el último paso de todos los
 * asistentes. Desde 2026-08-11 la actuación BÁSICA no tiene esa pestaña y
 * termina en Materials, así que el pie —con sus reglas de rol y de estado—
 * pasa a ser compartido en vez de duplicarse.
 *
 * Extracción PURA: mismo marcado, mismos `disabled`, mismos textos.
 *
 * Spec: docs/superpowers/specs/2026-08-11-basica-sin-fauna-design.md
 */
export const ActionWizardFooter = ({
  textButton,
  showSaveButton,
  saveButtonText,
  onBeforeSave,
  showValidateButton = true,
  onBeforeValidate,
  showPendingCertificationButton,
  pendingCertificationButtonText,
  onBeforePendingCertification,
  parentExpeditionOrderStatus,
  state,
}: ActionWizardFooterProps): JSX.Element => {
  const { t } = useTranslation(['forms', 'common']);

  // Expediente padre anulado o cerrado, o la propia actuación anulada: se
  // puede mirar, no escribir.
  const isFrozen =
    parentExpeditionOrderStatus === OrderState.Annulled ||
    parentExpeditionOrderStatus === OrderState.End ||
    state === OrderState.Annulled;

  return (
    <ButtonContainer>
      {showSaveButton && (
        <MainButton
          disabled={isFrozen}
          variant="secondary"
          text={saveButtonText || t('common:buttons.save')}
          type="submit"
          onClick={() => onBeforeSave?.()}
        />
      )}
      {showValidateButton && (
        <MainButton
          disabled={isFrozen}
          text={
            isFrozen
              ? t('common:buttons.continue')
              : textButton || t('common:buttons.continue')
          }
          type="submit"
          onClick={() => onBeforeValidate?.()}
        />
      )}
      {showPendingCertificationButton && (
        <MainButton
          disabled={isFrozen}
          text={
            pendingCertificationButtonText || t('validation:pendingCertification')
          }
          type="submit"
          onClick={() => onBeforePendingCertification?.()}
        />
      )}
    </ButtonContainer>
  );
};

export default ActionWizardFooter;
